;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import { DropdownMenuGroup, DropdownMenuLabel } from "@/components/ui/dropdown-menu"
import { cn } from "@/lib/utils"
import Menu from "../Menu"
import MenuItem from "../MenuItem"
import Divider from "../Divider"
import {
  TOP_NAV_MENU_TYPE_ACCOUNT,
  TOP_NAV_MENU_TYPE_BY_ADMIN_NAV_KEY,
  TOP_NAV_MENU_TYPE_LOGOUT,
} from "../constants"
import {
  ADMIN_DASHBOARD_NAV,
  ADMIN_PRIMARY_NAV,
  ADMIN_TOOLS_NAV,
  type AdminNavItem,
  type AdminNavKey,
} from "../../../../../lib/admin/adminNav"

/**
 * The "Manage" rows repeat the top-bar links, so they only show while the
 * host bar is collapsed to its hamburger. Literal classes: Tailwind can't
 * extract classes built from template literals.
 */
const HIDE_AT_TOP_BAR = {
  600: "min-[600px]:hidden",
  700: "min-[700px]:hidden",
} as const

// ~11 rows are taller than a small phone; cap to the space Radix measures
// below the trigger and scroll (the legacy content is max-h-none).
const SCROLLABLE_CONTENT_CLASSES =
  "max-h-(--radix-dropdown-menu-content-available-height) overflow-y-auto"

const GROUP_CLASSES = "px-[5px] py-1"

const SECTION_LABEL_CLASSES =
  "px-[11px] pt-1 pb-0.5 font-roboto text-[11px] font-medium tracking-[0.08em] uppercase text-[rgba(0,0,0,0.6)]"

export default function MenuAdmin({
  trigger,
  handleLogout,
  topBarBreakpoint,
  activeKey,
  activeAriaCurrent = "page",
}: {
  trigger: React.ReactElement
  handleLogout: () => void | Promise<void>
  /** Width at which the host bar shows its desktop links (TopNavBarAdmin 600, TopNavBar 700) */
  topBarBreakpoint: 600 | 700
  /** Nav item for the page being viewed (see activeAdminNavKey) */
  activeKey?: AdminNavKey | null
  /** "true" when the page is inside the active item's section (a detail page) */
  activeAriaCurrent?: "page" | "true"
}) {
  const manageLabelId = React.useId()
  const toolsLabelId = React.useId()
  const hideAtTopBar = HIDE_AT_TOP_BAR[topBarBreakpoint]

  const renderRow = (item: AdminNavItem) => (
    <MenuItem
      key={item.key}
      topNavMenuItemType={TOP_NAV_MENU_TYPE_BY_ADMIN_NAV_KEY[item.key]}
      active={item.key === activeKey}
      ariaCurrent={activeAriaCurrent}
      dense
    />
  )

  return (
    <Menu trigger={trigger} contentClassName={SCROLLABLE_CONTENT_CLASSES}>
      <div className={GROUP_CLASSES}>{renderRow(ADMIN_DASHBOARD_NAV)}</div>
      <Divider className={hideAtTopBar} />
      <DropdownMenuGroup
        aria-labelledby={manageLabelId}
        className={cn(GROUP_CLASSES, hideAtTopBar)}
      >
        <DropdownMenuLabel id={manageLabelId} className={SECTION_LABEL_CLASSES}>
          Manage
        </DropdownMenuLabel>
        {ADMIN_PRIMARY_NAV.map(renderRow)}
      </DropdownMenuGroup>
      <Divider />
      <DropdownMenuGroup aria-labelledby={toolsLabelId} className={GROUP_CLASSES}>
        <DropdownMenuLabel id={toolsLabelId} className={SECTION_LABEL_CLASSES}>
          Tools
        </DropdownMenuLabel>
        {ADMIN_TOOLS_NAV.map(renderRow)}
      </DropdownMenuGroup>
      <Divider />
      <div className={GROUP_CLASSES}>
        <MenuItem topNavMenuItemType={TOP_NAV_MENU_TYPE_ACCOUNT} dense />
        <MenuItem
          topNavMenuItemType={TOP_NAV_MENU_TYPE_LOGOUT}
          handleLogout={handleLogout}
          dense
        />
      </div>
    </Menu>
  )
}
